import { render, staticRenderFns } from "./TypeSpotFolderForm.vue?vue&type=template&id=28382142&"
import script from "./TypeSpotFolderForm.vue?vue&type=script&lang=js&"
export * from "./TypeSpotFolderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports